// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N400A, N900 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DescriptionWrapper = styled.div({
	width: '100%',
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DescriptionReadView = styled.div<{
	isLoading: boolean;
	isEmpty: boolean;
}>`
	color: ${({ isLoading, isEmpty }) => {
		if (isEmpty || isLoading) {
			return token('color.text.disabled', N400A);
		}

		return token('color.text', N900);
	}};
`;
